import heroImage from '@/assets/images/works/projects/hyperdrive/hyperdrive-logo.png'
import compareLeft from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-left.mp4'
import compareRight from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-right.png'
import heroLogo from '@/assets/images/works/projects/cassian/cassian-logo.png'

export default {
  meta: {
    title: 'CASSIAN',
    headline: 'Consultores de <br> <span class="text-electric-purple">Confiança.</span>',
    label: 'Estudo de Caso 03',
    description:
      'Renovação digital abrangente para uma firma líder de auditoria e consultoria na Tanzânia.',
    chips: [
      { text: 'Corporativo', dotColor: 'bg-orange-500' },
      { text: 'Fintech', dotColor: 'bg-blue-500' },
      { text: '2023' },
    ],
    heroImage:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1920&auto=format&fit=crop',
    heroLogo: heroLogo,
  },
  sidebar: {
    title: 'Índice',
    meta: [
      { label: 'Cliente', value: 'Cassian & Associates' },
      { label: 'Tipo', value: 'Site Corporativo' },
      { label: 'Função', value: 'Desenvolvedor Líder' },
      { label: 'Stack', value: 'Vue 3, Tailwind, Pinia, Firebase' },
      { label: 'Localização', value: 'Dar Es Salam, Tanzânia (Remoto)' },
      { label: 'Ano', value: '2023' },
    ],
    cta: 'Ver Site',
    ctaLink: 'https://cassian.co.tz/',
    secondaryCta: 'Ver Código',
    secondaryCtaLink: '#',
    repoLink: null,
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Resumo',
      title: 'Contexto do Projeto',
      highlight:
        'O objetivo principal foi executar uma renovação abrangente da marca corporativa e do site da Cassian para elevar a imagem da empresa e a experiência do usuário.',
      cards: [
        { title: 'Cliente', text: 'Cassian & Associates' },
        { title: 'Setor', text: 'Serviços Fiscais e Corporativos' },
        { title: 'Serviços', text: 'Branding, Desenv. Web, UX/UI' },
        { title: 'Resultado', text: '+40% Geração de Leads' },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Conceito',
      label: 'O Desafio',
      title: 'Modernizando a Tradição',
      description:
        'As empresas fiscais muitas vezes parecem rígidas. Precisávamos transmitir <strong>autoridade e precisão</strong>, ao mesmo tempo em que parecíamos modernos, acessíveis e tecnológicos. O desafio era equilibrar essas forças opostas em uma identidade digital coesa.',
      tags: ['Rebranding', 'Vue 3', 'Performance', 'SEO'],
    },
    problema: {
      id: 'problema',
      menuLabel: 'Desafio',
      title: 'O Problema',
      description:
        'A presença digital anterior não refletia a escala e a experiência reais da empresa. Os usuários achavam difícil navegar por ofertas de serviços complexas, levando a altas taxas de rejeição.',
      stats: [
        { value: '3.5s', label: 'Tempo Médio Carregamento' },
        { value: '65%', label: 'Tráfego Móvel' },
        { value: '15%', label: 'Taxa de Rejeição' },
      ],
    },
    transformacion: {
      id: 'transformacion',
      menuLabel: 'Comparação',
      title: 'Antes e Depois',
      beforeLabel: 'Site Antigo',
      afterLabel: 'Site Novo',
      instruction: 'Arraste para comparar',
      beforeImage: compareLeft,
      afterImage: compareRight,
    },
    branding: {
      id: 'branding',
      menuLabel: 'Identidade',
      title: 'Identidade Visual',
      description:
        'Uma linguagem de design ousada e profissional que equilibra confiabilidade com dinamismo moderno.',
      palette: [
        { name: 'Laranja Principal', hex: '#FF5D16' },
        { name: 'Escuro Profissional', hex: '#1A1A24' },
        { name: 'Azul Acento', hex: '#00B6EA' },
        { name: 'Branco Puro', hex: '#FFFFFF' },
      ],
      typography: 'Filson Soft (Títulos) + Noto Sans (Corpo)',
      gallery: [
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Papelaria',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Redes+Sociais',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Cartao+Visitas',
        'https://placehold.co/600x400/1A1A24/FF5D16/png?text=Merch',
      ],
    },
    proceso: {
      id: 'proceso',
      menuLabel: 'Processo',
      title: 'Processo de Desenvolvimento',
      subtitle: 'Uma Abordagem em Fases',
      description: `
        <div class="space-y-4">
          <div><strong class="text-electric-purple text-lg block mb-1">Fase 1: Pesquisa e Análise</strong> Investigação minuciosa da marca Cassian e da concorrência, definindo objetivos específicos do projeto e analisando tendências atuais de web design.</div>
          <div><strong class="text-electric-purple text-lg block mb-1">Fase 2: Design e Desenvolvimento</strong> Definição de elementos visuais (logo, paleta, tipografia) e construção do novo site corporativo usando Vue 3 e Tailwind CSS.</div>
          <div><strong class="text-electric-purple text-lg block mb-1">Fase 3: Testes e Lançamento</strong> Testes exaustivos para garantir UX ideal, seguidos pelo lançamento oficial e implementação da nova identidade corporativa.</div>
        </div>
      `,
      images: [
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+1',
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+2',
        'https://placehold.co/600x800/1A1A24/FF5D16/png?text=Process+3',
      ],
    },
    solucion: {
      id: 'solucion',
      menuLabel: 'Galeria',
      label: 'Resultado Final',
      title: 'A Experiência',
      images: [
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Mobile+View',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Pagina+Servicos',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Sobre+Nos',
        'https://placehold.co/800x1200/1A1A24/FFFFFF/png?text=Contato',
      ],
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Tecnologia',
      title: 'Engenharia',
      description: 'Uma arquitetura de stack moderna projetada para escalabilidade e desempenho.',
      categories: [
        { name: 'Design', items: ['Figma', 'Photoshop', 'Illustrator', 'Adobe Fonts'] },
        { name: 'Frontend', items: ['Vue 3', 'Composition API', 'Vite'] },
        { name: 'Estilos', items: ['Tailwind CSS', 'SCSS', 'PostCSS'] },
        { name: 'Estado/Lógica', items: ['Pinia', 'Firebase', 'Axios'] },
      ],
    },
  },
}
